import React from 'react'
import { DATE_RANGE_PRESETS, type DateRangePresetId } from '../lib/dateRangePresets'
import type { DateRange } from '../lib/listFilterSort'

interface DateRangePresetBarProps {
  preset: DateRangePresetId
  custom: DateRange
  onPresetChange: (preset: DateRangePresetId) => void
  onCustomChange: (range: DateRange) => void
  className?: string
}

const chipBase =
  'inline-flex items-center justify-center min-h-[36px] px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors'
const chipOn = 'bg-blue-600 text-white'
const chipOff =
  'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
const dateInputCls =
  'min-h-[40px] min-w-0 px-2.5 py-1.5 border border-gray-300 rounded-xl text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500'

export function DateRangePresetBar({
  preset,
  custom,
  onPresetChange,
  onCustomChange,
  className = '',
}: DateRangePresetBarProps) {
  return (
    <div className={className} role="group" aria-label="Date range">
      <div className="flex flex-wrap gap-2">
        {DATE_RANGE_PRESETS.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => onPresetChange(item.id)}
            aria-pressed={preset === item.id}
            className={`${chipBase} ${preset === item.id ? chipOn : chipOff}`}
          >
            {item.label}
          </button>
        ))}
      </div>
      {preset === 'custom' && (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <label className="sr-only" htmlFor="dashboard-range-from">
            From
          </label>
          <input
            id="dashboard-range-from"
            type="date"
            value={custom.from}
            onChange={(e) => onCustomChange({ ...custom, from: e.target.value })}
            aria-label="From date"
            className={dateInputCls}
          />
          <span className="text-gray-400 text-sm flex-shrink-0">to</span>
          <label className="sr-only" htmlFor="dashboard-range-to">
            To
          </label>
          <input
            id="dashboard-range-to"
            type="date"
            value={custom.to}
            onChange={(e) => onCustomChange({ ...custom, to: e.target.value })}
            aria-label="To date"
            className={dateInputCls}
          />
        </div>
      )}
    </div>
  )
}
